import React from 'react';
import { BIGGER_SPACING } from '../../config/designSystem/Colors';
import { BIG_MARGIN_VERTICAL_FN, isWeb} from '../../config/designSystem/Layout';
import { Entypo } from '@expo/vector-icons';
import { H1 } from '../../config/designSystem/typography';
import { TouchableOpacity, View } from 'react-native';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

const BackIcon = ({ tintColor, size }: { tintColor: string; size: number }) => {
  return <Entypo name="chevron-small-left" color={tintColor} size={size} style={{ marginLeft: 5 }} />;
};
export interface LegacyTitleProps {
  title: string;
  withBack: boolean;
  color: string;
  size: number;
  onBack?: () => void;
}
export default function LegacyTitle(props: LegacyTitleProps) {
  const { height } = useAvailableDimensions();

  return (
    <View
      style={[
        {
          marginHorizontal: BIGGER_SPACING,
          marginTop: Math.min(BIG_MARGIN_VERTICAL_FN(height),20),
        }
      ]}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            justifyContent:'center',
            alignItems: 'center',
          }}
        >
          {props.withBack && (
            <TouchableOpacity onPress={props.onBack} style={{marginRight:20}} >
              <View style={{paddingLeft:0}}>
                <BackIcon tintColor={props.color} size={30} />
              </View>
            </TouchableOpacity>
          )}
          <View style={[(props.withBack && isWeb) &&{alignItems:'center',flex:1}]}>
            <H1 color={props.color}>
              {props.title}
            </H1>
          </View>
        </View>
      </View>
    </View>
  );
}

